import React, { useEffect, useState } from 'react'
import { Collapse, Form } from 'react-bootstrap';
import Breadcrumb from "../components/common/Breadcrumb"

import { ConvertToDMY, ConvertToDMYHIS } from '../helpers/uttils';
import Link from '../components/common/Link';
import { useDispatch } from 'react-redux';
import { Postdata } from '../helpers/api.service';
import ModalPopup from '../components/common/Modal';
import HttpService from '../helpers/httpServices';
import { message } from '../redux/actions/toastActions';
import Page from '../helpers/config';
import Title from '../components/common/Title';
import DataTableBase from "../components/common/DataTableBase"

const SchoolList = () => {
    const [data, setData] = useState([]);
    const [isloading, setIsloading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setperPage] = useState(Page.records);
    const [currentPage, setcurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const dispatch = useDispatch();
    const [open, setOpen] = useState(true);
    const [search, setSearch] = useState(false);
    const [modaldelete, setmodalDelete] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [modalswitch, setmodalswitch] = useState(false);
    const [modalswitchcontent, setmodalswitchcontent] = useState([0, 0]);



    const columns = [
        {
            name: 'Logo',
            cell: (row) =>
                <div className="avatar auto">
                    {console.log("row.logo",row.logo)}
                    <img
                        alt={row._id}
                        src={row.logo}
                    />
                </div>,
            width: "200px"
        },
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Mobile Number',
            selector: row => row.mobile_number,
        },
        {
            name: 'Email',
            selector: row => row.email,
        },
        {
            name: 'Address',
            selector: row => row.address,
        },
        {
            name: 'Status',
            cell: (row) =>
                <Link status={row.status}>
                    <Form.Check
                        type="switch"
                        checked={row.status}
                        onChange={e => handleStatusChange(row._id, e.target.checked)}
                    />
                </Link>,
            button: true,
        },
        {
            name: 'Action',
            id: 'actions',
            // hide: (!CheckPermission(permission, '/banner-management/add') && 999999),
            cell: (row) =>
                <span className="actions">
                    <Link to={`/school/edit/${row._id}`} className="btn-link">Edit</Link>
                    <div className="btn-link text-primary cp" onClick={() => { setDeleteId(row._id); setmodalDelete(true) }}>
                        Delete
                    </div>
                </span>,
            button: true,
        }
    ];

    const handleStatusChange = (id, status) => {
        setmodalswitchcontent([id, status]);
        setmodalswitch(true);
    };

    const handleDelete = () => {

        if (deleteId && deleteId !== "") {
            setmodalDelete(false);
            setIsloading(true);
            Postdata(HttpService.school_delete, {
                id: deleteId
            }).then((res) => {
                setRefresh(!refresh);
                dispatch(message(res.message));
            })
        }
    }

    const handleStatusChangeAction = () => {
        setmodalswitch(false);
        setIsloading(true);
        Postdata(HttpService.school_add, {
            id: modalswitchcontent[0],
            status: Number(modalswitchcontent[1])
        }).then((res) => {
            setRefresh(!refresh);
            dispatch(message(res.message));
        })
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setperPage(newPerPage);
        setcurrentPage(page);
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    useEffect(() => {
        if (search !== false) {
            const timeOutId = setTimeout(() => setRefresh(!refresh), 500);
            return () => clearTimeout(timeOutId);
        }
    }, [search]);

    useEffect(() => {
        setIsloading(true);
        Postdata(HttpService.school_list, {
            page: currentPage,
            perpage: perPage,
            search: (search ? search : ''),
        }).then((response) => {
            if (response.status === 200) {
                setData(response.data.schools);
                setTotalRows(response.data.count);
                setIsloading(false);
            } else {
                setIsloading(false);
                dispatch(message(response.message));
            }
        }).catch((e) => {
            setIsloading(false);
            dispatch(message(e.message));
        });
    }, [currentPage, perPage, refresh]);


    return (
        <>
      <Title name='School Management' />

      <ModalPopup
        className="alert-box-popup"
        show={modalswitch}
        size="sm"
        onHide={() => setmodalswitch(false)}
        heading="Are you sure?"
      >
        <i className="mdi mdi-check"></i>
        <p>You want to change this status!</p>
        <div className='actions'>
          <button className="btn btn-primary" onClick={() => handleStatusChangeAction()}>Yes, Change Status</button>
          <button className="btn btn-danger" onClick={() => setmodalswitch(false)}>Cancel</button>
        </div>
      </ModalPopup>

      <ModalPopup
        className="alert-box-popup"
        show={modaldelete}
        size="sm"
        onHide={() => setmodalDelete(false)}
        heading="Are you sure?"
      >
        <i className="mdi mdi-check"></i>
        <p>You want to delete the School!</p>
        <div className='actions'>
          <button className="btn btn-primary" onClick={() => handleDelete()}>Yes, Delete It</button>
          <button className="btn btn-danger" onClick={() => setmodalDelete(false)}>Cancel</button>
        </div>
      </ModalPopup>

      <div className="row">
        <div className="col-lg-4">
          <h4>School Management</h4>
          <Breadcrumb
            active="School Management"
          />
        </div>
        <div className="col-lg-8 text-end">
          
             <Link to={'/school/add'} className="btn btn-custom">Add New School</Link> 
          
          <button className="btn btn-danger" onClick={() => setOpen(!open)}>Search</button>
        </div>
      </div>

      <Collapse in={open}>
        <div>
          <div className="card">
            <p className="card-header">Search</p>
            <div className="card-body">
              <div className="row">
                <div className='col-lg-3'>
                  <Form.Group className="form-group mb-0">
                    <Form.Label>Search By</Form.Label>
                    <Form.Select 
                    className='customOption'
                    onChange={e => setSearch(e.target.value)} >
                      <option value="name">Name</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-lg-3">
                  <Form.Group className="form-group mb-0">
                    <Form.Label>Search</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={e => setSearch(e.target.value)}
                      required
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>

      <div className="card">
        <p className="card-header">List of Schools</p>
        <div className="card-body">
          <DataTableBase
            columns={columns}
            loader={isloading}
            data={data}
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
        </div>
      </div>
    </>
    )
}

export default SchoolList